module.exports = __webpack_public_path__ + "static/media/work-list-panel.abc89d3d.PNG";